import { Link } from 'react-router-dom';
import { getProjects } from '../../utils/getProjects';
import ProjectItem from '../projectItem';
import './_projectList.scss';

const projects = getProjects(4);

function ProjectList() {
  return (
    <div className='projects'>
        <h2>Proyectos</h2>
        <div className='project-list'>
            {
                projects.map(pro => (
                    <ProjectItem key={pro.name} project={pro} />
                ))
            }
        </div>
        <Link to="/projects" className='link'>Ver más proyectos {'>'}</Link>
    </div>
  )
}

export default ProjectList